import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./components/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect, useState, Suspense, lazy } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Spinner, Container } from "react-bootstrap";

// Static imports (Critical path - First Contentful Paint)
import Navbarr from "./components/Navbarr";
import Home from "./components/Home";
import PrivateRoute from "./routes/PrivateRouter";
import { getuser } from "./Redux/userSlice";
import ProfileUser from "./components/ProfileUser";

// Lazy loaded routes (Code Splitting)
const About = lazy(() => import("./components/About"));
const Contact = lazy(() => import("./components/Contact"));
const Login = lazy(() => import("./components/Login"));
const Profile = lazy(() => import("./components/Profile"));
const PrepMyFuture = lazy(() => import("./components/PrepMyFuture"));
const BusinessFrench = lazy(() => import("./components/BusinessFrench"));
const FrenchCourses = lazy(() => import("./components/FrenchCourses"));
const TEF = lazy(() => import("./components/TEF"));
const TCF = lazy(() => import("./components/TCF"));
const DelfDalf = lazy(() => import("./components/DelfDalf"));
const ConditionDeVente = lazy(() => import("./components/ConditionDeVente"));
const Otp = lazy(() => import("./components/Otp"));
const FormDFP = lazy(() => import("./components/FormDFP"));
const FormTef = lazy(() => import("./components/FormTef"));
const PaymentSuccess = lazy(() => import("./components/PaymentSuccess"));
const PaymentCancelled = lazy(() => import("./components/PaymentCancelled"));
const DashAdmin = lazy(() => import("./components/DashAdmin"));
const DashSousAdmin = lazy(() => import("./components/DashSousAdmin"));

function App() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") || "fr",
  );

  const dispatch = useDispatch();

  // Sync language on load
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  // Fetch current user on mount if token exists
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(getuser(token));
    }
  }, [dispatch]);

  // Fallback loader component UI
  const FallbackLoader = () => (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" variant="danger" />
    </Container>
  );

  return (
    <div className="App">
      <Navbarr
        language={language}
        setLanguage={setLanguage}
        t={t}
        i18n={i18n}
      />
      <Suspense fallback={<FallbackLoader />}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home t={t} />} />
          <Route path="/about" element={<About t={t} />} />
          <Route path="/login" element={<Login t={t} />} />
          <Route path="/French-Courses" element={<FrenchCourses t={t} />} />
          <Route path="/Business-French" element={<BusinessFrench t={t} />} />
          <Route path="/TEF" element={<TEF t={t} />} />
          <Route path="/TCF" element={<TCF t={t} />} />
          <Route path="/DELF-DALF" element={<DelfDalf t={t} />} />
          <Route path="/PrepMyFuture" element={<PrepMyFuture t={t} />} />
          <Route path="/contact" element={<Contact t={t} />} />
          <Route
            path="/ConditionDeVente"
            element={<ConditionDeVente t={t} />}
          />
          <Route path="/otp-code" element={<Otp t={t} />} />
          <Route path="/DFP-registration" element={<FormDFP t={t} />} />
          <Route path="/TEF-registration" element={<FormTef t={t} />} />
          <Route path="/payment-success" element={<PaymentSuccess t={t} />} />
          <Route
            path="/payment-cancelled"
            element={<PaymentCancelled t={t} />}
          />

          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/profile" element={<Profile t={t} />} />
            <Route path="/dash-admin" element={<DashAdmin />} />
            <Route path="/user/:id" element={<ProfileUser />} />
            <Route path="/dash-s-admin" element={<DashSousAdmin />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
